import React from 'react';
import cn from 'classnames';
import { formatSaveStatus } from '../helpers/formatters';
import FormError from './FormError';

const Form = ({
  handleSubmit,
  saveStatus,
  error,
  submit,
  children,
  noSubmitBtn = false,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      {children}
      {error && <FormError error={error} />}
      <br />
      {!noSubmitBtn && (
        <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
          {submit}
        </button>
      )}
      <span className={cn({ 'submit-status': !noSubmitBtn })}>
        {formatSaveStatus(saveStatus)}
      </span>
    </form>
  </div>
);

export default Form;
